import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink';
import { Image } from 'Components/frameworks/image/Image';
type Props = {
  className?: string;
  ratingImage?:
    | {
        alt: string;
        src: string;
      }
    | null
    | undefined;
};
export const ProductIntroductionActions = ({ className, ratingImage = {} }: Props) => {
  const track = useTracking({
    actionGA: 'practicalInfos',
    categoryGA: 'resort',
    labelGA: 'tripAdvisorAnchor',
  });
  return (
    <div className={classnames('flex flex-col items-center sm:items-stretch', className)}>
      {ratingImage && ratingImage.src && (
        <DynamicLink
          className="rounded-12 border-1 border-sand p-5 text-center leading-0"
          onClick={() => track()}
          url="#tripadvisor"
        >
          <Image
            altMsg={ratingImage.alt}
            dontChangeAnything
            imageUrl={ratingImage.src}
            ratioDisplay={3 / 20}
          />
        </DynamicLink>
      )}
    </div>
  );
};
